module.exports = __webpack_public_path__ + "static/img/notice.ab432f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/myapp/notice.png
// module id = JQlO
// module chunks = 39